/**
 * @description Auto table持久化完整配置项.
 * 注意: 有表头合并/单元格合并, 此功能无法使用, 因为字段被排序或者隐藏，表格列会变化, 从而合并单元格将会变乱.
 *       如果你坚持需要，那么我建议利用排序或隐藏回调进行处理
 *
 *  - 字段配置: 排序/字段隐藏显示
 */

import { IFieldOptAPI } from '../field-model-extension-api';

export interface IAPIProtractedRes<T> {
  readonly key: string;
  readonly value: T;
}

export enum ProtractedType {
  'local' = 'local',
  'remote' = 'remote',
}

// 公共定义
export interface IProtractedCommonConfig {
  readonly isEnable: boolean; // 是否开启持久化
  readonly guid: string; // auto table字段配置的唯一标识
  readonly type?: ProtractedType; // 持久类型, 默认ProtractedType.local
  readonly remoteConfig?: IProtractedRemoteConfig; // 仅ProtractedType.remote有效
}

export enum ProtractedFeature {
  'fieldConfig' = 'fieldConfig', // 字段配置
  'fontSize' = 'fontSize', // 字体大小
}

// 远程存储配置
export interface IProtractedRemoteConfig {
  readonly getConfig: IFieldOptAPI; // 获取远程存储的数据
  readonly setConfig?: IFieldOptAPI; // 更新远程存储数据
}

// 字段配置持久化
export interface IProtractedFieldConfig extends IProtractedCommonConfig {}

// 持久化扩展项
export interface IAutoTableProtractedExtension {
  readonly [ProtractedFeature.fieldConfig]?: IProtractedFieldConfig;
  readonly [ProtractedFeature.fontSize]?: IProtractedCommonConfig;
}
